<template>
  <div class="uploadFileList">
    <el-upload
      class="upload-demo"
      :action="actionUrl"
      :data="imgData"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :before-upload="beforeUpload"
      :on-success="onImgSuccess"
      multiple
      :limit="fileLength"
      :on-exceed="handleExceed"
      :file-list="fileList"
      ref="fileUp"
      :disabled="disabled"
    >
      <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传文件</el-button
      >
      <div slot="tip" class="el-upload__tip">
        <div v-for="(item, index) in claim" :key="index">
          {{ index + 1 }}、{{ item.msg }}
          <div v-if="item.child">
            <p v-for="(ite, ind) in item.child" :key="ind">{{ ite }}</p>
          </div>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    successFile: {
      type: Function,
    },
    typeFile: {
      type: String,
      default: () => '',
    },
    //upLoadData
    imgData: {
      type: Object,
      default: () => {},
    },
    actionUrl: {
      type: String,
      default: () => '',
    },
    claim: {
      type: Array,
      default: () => [],
    },
    pFileList: {
      type: Array,
      default: () => [],
    },
    fileLength: {
      type: Number,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      fileList: [],
      flag: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.fileList = this.pFileList;
    }, 0);
  },
  methods: {
    //获取随机key
    setKey(flag) {
      var myDate = new Date();
      var key =
        'zc_' +
        flag +
        Math.round(Math.random() * 10000) +
        myDate.getTime() +
        myDate.getFullYear() +
        myDate.getMonth() +
        myDate.getDate();
      return key;
    },
    //调整文件列表
    changeFileList(fileList) {
      let arr = [];
      fileList.forEach((item) => {
        let url = this.getFileUrl(item.response);
        arr.push({
          uid: item.uid,
          name: item.name,
          response: item.response,
          url,
        });
      });
      return arr;
    },
    //获取文件url地址
    getFileUrl(response) {
      var doc = new DOMParser().parseFromString(response, 'text/xml');
      let url = doc.getElementsByTagName('Location')[0].innerHTML;
      return url;
    },
    //文件上传成功回调
    onImgSuccess(response, file, fileList) {
      let arr = this.changeFileList(fileList);
      this.successFile(arr);
      this.flag = false;
    },
    //文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      if (this.flag) {
        this.flag = false;
      } else {
        let arr = this.changeFileList(fileList);
        this.successFile(arr);
      }
    },
    //点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
      if (file.response) {
        window.open(this.getFileUrl(file.response));
      } else {
        window.open(file.url);
      }
    },
    //文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //文件列表移除文件时的钩子
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    //文件上传之前函数
    beforeUpload(file) {
      if (this.flag) return false;
      this.flag = true;
      this.$refs.fileUp.data.key = this.setKey('gsb');
      let isIMG;
      let fileName = file.name;
      let pos = fileName.lastIndexOf('.');
      let lastName = fileName.substring(pos, fileName.length);
      switch (this.typeFile) {
        //图片
        case 'image':
          isIMG =
            file.type === 'image/jpg' ||
            file.type === 'image/jpeg' ||
            file.type === 'image/png';
          if (!isIMG) {
            this.$message.error('上传头像图片只支持jpg、jpeg、png格式！');
          }
          break;
        //压缩包
        case 'archive':
          //rar，zip，tar，cab，7z
          isIMG =
            lastName.toLowerCase() === '.zip' ||
            lastName.toLowerCase() === '.rar' ||
            lastName.toLowerCase() === '.tar' ||
            lastName.toLowerCase() === '.cab' ||
            lastName.toLowerCase() === '.7z';
          if (!isIMG) {
            this.$message.error('文件必须为压缩文件！');
          }
          break;
        //pdf
        case 'pdf':
          //rar，zip，tar，cab，7z
          isIMG = file.type === 'application/pdf';
          if (!isIMG) {
            this.$message.error('文件必须为PDF格式！');
          }
          break;
        default:
          isIMG = true;
          break;
      }
      return isIMG;
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadFileList {
  width: 100%;
  .el-button {
    width: 100px;
    height: 32px;
    padding: 0;
    border-radius: 4px;
    border: 1px solid rgba(255, 138, 1, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 138, 1, 1);
    line-height: 22px;
    background: #fff;
  }
  .upload-demo {
    width: 435px;
  }
  .el-upload__tip {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(159, 161, 168, 1);
    line-height: 18px;
    p {
      margin-left: 25px;
      line-height: 22px;
      color: #f00;
    }
  }
}
</style>
